<template>
  <div class="professionalIdentification">
    <div>
      <div>
        <h1 class="professionalIdentification__title">
          Dados do médico que emitiu seu pedido médico
        </h1>
        <p class="professionalIdentification__subtitle">
          Preencha os campos abaixo com os dados disponíveis em seu pedido médico.
        </p>
      </div>
      <div class="professionalIdentification__form">
        <div>
          <p class="professionalIdentification__label">Qual é a especialidade do médico?</p>
          <VSelect
            required
            v-model="identificationSpecialty"
            :options="optionsSpecialty"
            label="Selecione a especialidade"
          />
        </div>
        <div>
          <p class="professionalIdentification__label">Qual é o estado?</p>
          <VSelect
            required
            v-model="identificationUf"
            :options="optionsUf"
            label="Insira o estado"
          />
        </div>
        <div>
          <p class="professionalIdentification__label">Qual é o número de identificação ?</p>
          <VInput
            required
            v-mask="'###########'"
            label="Digite o número de identificação"
            class="professionalIdentification__input"
            v-model="identificationValue"
          />
        </div>
      </div>
      <div>
        <VButton
          class="professionalIdentification__btn"
          text="Continuar"
          variant="primary"
          :disabled="disabledBtn"
          @click.native="searchProfessional()"
        />
        <VButton
          text="Não encontrei os dados"
          variant="secondary"
          @click.native="toggleDrawer('helpToUse')"
        />
      </div>
    </div>

    <DrawerBottom
      :open="openDrawer"
      @toggle="openDrawer = !openDrawer"
      @close="openDrawer = false"
      v-if="openDrawer"
    >
      <template #content>
        <DrawerHelp
          @toggle-drawer="toggleDrawer()"
          @go-to-next-page="goToNextPage()"
          v-if="drawerHelpToUse"
        />
        <DrawerOtherSpeciality
          @toggle-drawer="toggleDrawer()"
          @go-to-next-page="goToNextPage()"
          v-if="identificationSpecialtyIsOther"
        />
      </template>
    </DrawerBottom>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DrawerBottom from '@/components/drawerBottom.component.vue';
import DrawerHelp from './partials/DrawerHelp.vue';
import DrawerOtherSpeciality from './partials/DrawerOtherSpeciality.vue';
import ufOptions from './ufBrazil';
import { dataLayersMixin } from '@/utils/mixins';

export default {
  name: 'professionalIdentification',
  components: {
    DrawerBottom,
    DrawerHelp,
    DrawerOtherSpeciality,
  },
  mixins: [dataLayersMixin],
  data: () => ({
    optionsSpecialty: [
      { label: 'CRM - Medicina', value: 'CRM' },
      { label: 'CRO - Odontologia', value: 'CRO' },
      { label: 'Outro', value: 'other' },
    ],
    identificationSpecialty: '',
    identificationUf: '',
    identificationValue: '',
    openDrawer: false,
    drawerHelpToUse: false,
    identificationSpecialtyIsOther: false,
  }),
  computed: {
    ...mapState({
      professionalData: ({ professionalIdentification }) =>
        professionalIdentification.professionalData,
    }),
    optionsUf() {
      return ufOptions.map((uf) => {
        return { label: uf.state, value: uf.state };
      });
    },
    disabledBtn() {
      if (
        this.identificationSpecialty &&
        this.identificationSpecialty !== 'other' &&
        this.identificationUf &&
        this.identificationValue
      ) {
        return false;
      }
      return true;
    },
  },
  watch: {
    identificationSpecialty(newValue) {
      if (newValue === 'other') {
        this.toggleDrawer('specialtyIsOther');
      }
    },
  },
  created() {
    if (this.professionalData) {
      this.identificationSpecialty = this.professionalData.council;
      this.identificationValue = this.professionalData.registryNumber;
      this.identificationUf = this.professionalData.state;
    }
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Identificação do profissional',
    });
  },
  methods: {
    ...mapActions(['searchMdmProfessional']),
    async searchProfessional() {
      await this.searchMdmProfessional({
        council: this.identificationSpecialty,
        value: this.identificationValue,
        uf: this.identificationUf,
      });

      if (
        this.professionalData?.council &&
        this.professionalData?.registryNumber &&
        this.professionalData?.state
      ) {
        return this.goNextStep('check_professional_identification');
      }

      this.mostCommonPagesAnalytics({
        eventType: 'funnel_step',
        currentStep: 'Cadastro do profissional não encontrado',
      });

      return this.goNextStep('questions_step');
    },
    toggleDrawer(drawer) {
      if (drawer && drawer === 'helpToUse') this.drawerHelpToUse = true;
      if (drawer && drawer === 'specialtyIsOther') this.identificationSpecialtyIsOther = true;

      this.openDrawer = !this.openDrawer;

      if (!drawer) {
        this.drawerHelpToUse = false;
        this.identificationSpecialtyIsOther = false;
        this.identificationSpecialty = '';
      }
    },
    goToNextPage() {
      return this.goNextStep('questions_step');
    },
  },
};
</script>

<style lang="scss">
.professionalIdentification {
  &__title {
    color: #292929;
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 8px;
  }

  &__subtitle {
    color: #363636;
    font-size: 16px;
  }

  &__form {
    overflow: auto;
    scroll-behavior: auto;
    max-height: 50vh;
  }

  &__label {
    color: #363636;
    font-size: 16px;
    margin-top: 32px;
    text-align: left;
    margin-bottom: 8px;
  }

  &__input {
    height: 48px;
    margin-bottom: 48px;
  }

  &__btn {
    margin-bottom: 8px;
  }
}
</style>
